/* eslint-disable import/prefer-default-export */
import { getForm } from '../Components/FormSetup/formSlice';
import { apiSlice } from './apiSlice';

const templatesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTemplates: builder.query({
      query: () => '/templates/all',
      providesTags: () => ['Templates'],
    }),
    getTemplate: builder.query({
      query: (id) => `/templates/${id}`,
      providesTags: (result, error, arg) => [{ type: 'Template', id: arg }],
    }),
    getTemplateDraft: builder.query({
      query: (id) => `/templates/${id}/draft`,
      providesTags: (result, error, arg) => [{ type: 'Template', id: arg, v: 'draft' }],
    }),
    updateTemplate: builder.mutation({
      queryFn: async (_, api, extraOptions, baseQuery) => {
        const state = api.getState();
        const template = getForm(state);

        return baseQuery({
          url: `/templates/${template.id}`,
          method: 'POST',
          body: { schema: { design: template.design }, name: template.name },
        });
      },
      invalidatesTags: (result, error, t) => {
        if (error) return [];
        return [{ type: 'Template', id: t.id, v: 'draft' }];
      },
    }),
    publishTemplate: builder.mutation({
      query: (id) => ({
        url: `/templates/${id}/publish`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, template) => {
        if (error) return [];
        return [{ type: 'Template', id: template.id }];
      },
    }),
    discardTemplateDraft: builder.mutation({
      query: (id) => ({
        url: `/templates/${id}/draft/discard`,
        method: 'POST',
      }),
      invalidatesTags: (result, error, t) => {
        if (error) return [];
        return [{ type: 'Template', id: t.id, v: 'draft' }];
      },
    }),
    newTemplate: builder.mutation({
      query: () => ({
        url: '/templates/new',
        method: 'POST',
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data: newTemplate } = await queryFulfilled;
          if (newTemplate.status === 'ok') {
            dispatch(
              apiSlice.util.updateQueryData('getTemplates', undefined, (draft) => {
                draft.push(newTemplate.template);
              }),
            );
          }
        } catch (e) {
          console.log('error al crear el template', e);
        }
      },
    }),
    deleteTemplate: builder.mutation({
      query: (id) => ({
        url: `/templates/${id}`,
        method: 'DELETE',
      }),
      async onQueryStarted(id, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          if (data.status === 'ok') {
            dispatch(
              apiSlice.util.updateQueryData('getTemplates', undefined, (draft) => draft.filter((f) => f.id !== id)),
            );
          }
        } catch (e) {
          console.log('error al borrar el form', e);
        }
      },
      invalidatesTags: (result, error, id) => [{ type: 'Template', id }],
    }),
    saveAsTemplate: builder.mutation({
      queryFn: async (args, api, extraOptions, baseQuery) => {
        const state = api.getState();
        const template = getForm(state);

        console.log('args', args);

        return baseQuery({
          url: '/templates/save',
          method: 'POST',
          body: {
            schema: { design: template.design },
            name: args.type === 'new' ? args.value : undefined,
            id: args.type !== 'new' ? args.value : undefined,
          },
        });
      },
      invalidatesTags: (result, error) => {
        if (error) return [];
        console.log('invalidate tags', result);
        return ['Templates', { type: 'Template', id: result.id, v: 'draft' }];
      },
    }),
    getPublicTemplates: builder.query({
      query: () => '/templates/public/all',
      providesTags: () => ['Public-templates'],
    }),
  }),
});

export const {
  useGetTemplateDraftQuery,
  useGetTemplateQuery,
  useLazyGetTemplateQuery,
  useGetTemplatesQuery,
  useUpdateTemplateMutation,
  usePublishTemplateMutation,
  useDiscardTemplateDraftMutation,
  useNewTemplateMutation,
  useDeleteTemplateMutation,
  useSaveAsTemplateMutation,
  useGetPublicTemplatesQuery,
} = templatesApiSlice;
